import React from "react";

export default function ({title, onClick}) {
  return <button type="button"
                 className="btn btn-sm btn-light-primary"
                 onClick={onClick}
  >
                            <span className="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12"
                                          height="2" rx="1"
                                          transform="rotate(-90 11 18)"
                                          fill="black"/>
                                    <rect x="6" y="11" width="12" height="2"
                                          rx="1" fill="black"/>
                                </svg>
                            </span>
    {title}
  </button>
}